import { useState } from 'react';
import { TextField } from '@zep-us/zus';
import { useTranslation } from 'next-i18next';
import { logger } from '@zep/core-logger';
import { useActivateVoucher, useClaimVoucher, useGetMyVouchers } from '@/api/gen/vouchers/vouchers.gen';
import { ZepQuizApiError } from '@/api/httpClient';
import { Button } from '@/ui_v3/components/button';
import { useVoucherAlertModal } from '../VoucherAlertModal';
export const VoucherCodeInput = () => {
  const {
    t
  } = useTranslation(['billing']);
  const [voucherCode, setVoucherCode] = useState<string>('');
  const {
    openVoucherAlertModal,
    openRegisterSuccessModal
  } = useVoucherAlertModal();
  const {
    data,
    refetch
  } = useGetMyVouchers();
  const {
    mutateAsync: claimVoucher,
    isPending: isRegistering
  } = useClaimVoucher();
  const {
    mutateAsync: activateVoucher
  } = useActivateVoucher();
  const vouchersData = data?.data;
  const canUseVouchers = vouchersData?.canUseVouchers || false;
  const handleRegisterVoucher = async (code: string) => {
    if (code.trim().length === 0) {
      return;
    }
    try {
      const claimedVoucher = await claimVoucher({
        data: {
          code
        }
      });
      const {
        campaignName,
        hashId
      } = claimedVoucher.data;
      logger.track('register_voucher_success', {
        voucher_id: hashId
      });
      const canActivate = await openRegisterSuccessModal(campaignName, canUseVouchers);
      if (canActivate) {
        await activateVoucher({
          voucherHashId: hashId
        });
        window.location.reload();
      }
      setVoucherCode('');
      void refetch();
    } catch (error) {
      if (error instanceof ZepQuizApiError) {
        logger.track('register_voucher_fail', {
          fail_reason: error.status
        });
        openVoucherAlertModal(error.status);
      }
    }
  };
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && voucherCode.trim().length > 0) {
      void handleRegisterVoucher(voucherCode.trim());
    }
  };
  return <div className="flex w-full flex-col items-end gap-xs mobile-lg:flex-1 mobile-lg:flex-row tablet-lg:max-w-[507px]" data-sentry-component="VoucherCodeInput" data-sentry-source-file="VoucherCodeInput.tsx">
      <TextField.Root required data-sentry-element="unknown" data-sentry-source-file="VoucherCodeInput.tsx">
        <TextField.Label data-sentry-element="unknown" data-sentry-source-file="VoucherCodeInput.tsx">{t('billing:voucher.register')}</TextField.Label>
        <TextField.Input placeholder={t('billing:voucher.registerPlaceholder')} value={voucherCode} onChange={e => setVoucherCode(e.target.value)} onKeyDown={handleKeyDown} data-sentry-element="unknown" data-sentry-source-file="VoucherCodeInput.tsx" />
      </TextField.Root>
      <Button variant="contained" intent="strong" size="lg" onClick={() => handleRegisterVoucher(voucherCode.trim())} disabled={!voucherCode.trim() || isRegistering} className="w-full shrink-0 mobile-lg:w-auto" data-sentry-element="Button" data-sentry-source-file="VoucherCodeInput.tsx">
        {t('billing:voucher.registerButton')}
      </Button>
    </div>;
};